import { render, staticRenderFns } from "./setting-zohoIntegration.vue?vue&type=template&id=65fd1fb8&scoped=true&"
import script from "./setting-zohoIntegration.vue?vue&type=script&lang=js&"
export * from "./setting-zohoIntegration.vue?vue&type=script&lang=js&"
import style0 from "./setting-zohoIntegration.vue?vue&type=style&index=0&id=65fd1fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd1fb8",
  null
  
)

export default component.exports